<app-address-header-card-widget
    [formControl]="formControl"
    [form]="form"
    [address]="model"
    [loadingSig]="this.options.formState.detailComponent.loading"
    [key]="this.key"
    (addressChanged)="onAddressChanged($event)"
    (assetChoose)="onAssetChoose($event)"
/>
